import React from 'react';

const Blogs = () => {
    return (
        <div className='container mt-5'>

            <h2 style={{color:'#2a5568'}}>Our Blogs</h2>
            <div className="row d-flex align-items-center justify-content-center">
                <div className="col-12 col-md-6 border border-success m-3 p-3">
                    <h2>What are semantic tags in HTML? Gives some examples.</h2>
                    <p><span className='fw-bold'>Answer:</span> Semantic tags create the meaning of html content that the understand to human and machine-readable way. Some examples of semantic tags header tag, main tag, footer tag etc.</p>
                </div>
                <div className="col-12 col-md-6 border border-success m-3  p-3">
                    <h2>What is difference between inline, inline-block, block element?</h2>
                    <p>
                        <span className='fw-bold'>Answer:</span> Here is the difference inline, inline-block, block elements of html---
                        Inline
                        Inline-block
                        block
                        Inline element take space it’s own width.
                        The inline-block properties value complies with both inline and block element properties.
                        Block element take full width space of web page.</p>
                </div>
            </div>
        </div>
    );
};

export default Blogs;